import React from 'react';
import { usePWA } from './usePWA';

const PWAInstallButton = () => {
  const { isInstallable, isInstalled, installApp } = usePWA();

  if (isInstalled) {
    return (
      <div className="fixed bottom-4 right-4 z-50 lg:hidden">
        <div className="bg-[#2D5A49] text-[#F4F0E6] px-4 py-2 rounded-lg shadow-lg flex items-center space-x-2">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          <span className="text-sm font-medium">Uygulama Kuruldu!</span>
        </div>
      </div>
    );
  }

  if (!isInstallable) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 lg:hidden">
      <button
        onClick={installApp}
        className="bg-[#E2B65A] hover:bg-[#F0CD82] text-[#1B1405] px-4 py-3 rounded-lg shadow-lg transition-all duration-300 flex items-center space-x-2 transform hover:scale-105"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
        <div className="text-left">
          <div className="text-sm font-semibold">Telefona Ekle</div>
          <div className="text-xs opacity-90">Uygulama gibi kullan</div>
        </div>
      </button>
    </div>
  );
};

export default PWAInstallButton;
